/*
 * @Author: tkp
 * @Date: 2023-01-31 16:35:53
 */
const state = {
    partView: '',
}
const mutations = {
    SET_PARTVIEW: (state, data) => {
        state.partView = data
    },
}
export default {
    namespaced: true,
    state,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js